const updates = [
  { time: '10分钟前', title: '某男星工作室凌晨发声明否认出轨传闻，称将追究造谣者法律责任', badge: '紧急' },
  { time: '28分钟前', title: '知名女主播直播中意外曝光同行聊天记录，涉及多名艺人隐私', badge: '新' },
  { time: '1小时前', title: '热门古装剧组被曝拖欠群演工资，劳动监察部门介入调查', badge: '追' },
  { time: '2小时前', title: '某歌手新专辑销量被质疑造假，粉丝晒购买记录反击黑粉', badge: '' },
  { time: '3小时前', title: '娱乐公司CEO被前员工举报偷税漏税，税务部门回应已收到材料', badge: '热' },
  { time: '4小时前', title: '某综艺节目导演组内部邮件泄露，淘汰名单提前曝光引争议', badge: '' },
  { time: '5小时前', title: '多位艺人社交账号同时被盗，发布不当内容后紧急删除致歉', badge: '' },
  { time: '6小时前', title: '娱乐圈知名经纪人被曝收取巨额回扣，旗下艺人纷纷解约', badge: '爆' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">实时快讯</h2>
          <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-semibold whitespace-nowrap">
            <span className="w-1.5 h-1.5 bg-primary-500 rounded-full animate-pulse"></span>
            LIVE
          </span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">分秒级追踪娱乐圈最新动态，明星黑料与八卦爆料一触即达</p>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-3.5 top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div
                  className={`absolute -left-8 md:-left-10 top-1.5 w-3 h-3 rounded-full border-2 border-background-100 ${
                    i === 0 ? 'bg-primary-500' : 'bg-background-300'
                  }`}
                ></div>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="block group cursor-pointer"
                >
                  <div className="flex items-start gap-3 flex-wrap">
                    <span className="text-xs text-foreground-500 whitespace-nowrap shrink-0">{item.time}</span>
                    <h3 className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors leading-relaxed flex-1 min-w-0">
                      {item.title}
                    </h3>
                    {item.badge && (
                      <span
                        className={`shrink-0 text-xs px-2 py-0.5 rounded-full font-semibold whitespace-nowrap ${
                          item.badge === '爆'
                            ? 'bg-primary-100 text-primary-700'
                            : item.badge === '热'
                            ? 'bg-accent-100 text-accent-700'
                            : item.badge === '追'
                            ? 'bg-secondary-100 text-secondary-700'
                            : item.badge === '紧急'
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-foreground-100 text-foreground-600'
                        }`}
                      >
                        {item.badge}
                      </span>
                    )}
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}